
// src/app/rtk-query/dynamic-base-query.ts
import {
    fetchBaseQuery,
    type BaseQueryFn,
    type FetchArgs,
    type FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import type { RootState } from '../redux/store';
import { selectAccessToken, selectTenantUrl } from '../redux/selectors/authSelector';

export const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const state = api.getState() as RootState;

    const tenantUrl = selectTenantUrl(state);
    const accessToken = selectAccessToken(state);

    // Fallback in case user/claim isn't ready yet
    let baseUrl = tenantUrl ? `${tenantUrl.replace(/\/+$/, '')}/api/v2.1` : '/api/v2.1';
    if (process.env.REACT_APP_LOCAL_API)
        baseUrl = process.env.REACT_APP_LOCAL_API;

    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            if (accessToken) headers.set('authorization', `Bearer ${accessToken}`);
            headers.set('accept', 'application/json');
            return headers;
        },
    });

    return rawBaseQuery(args, api, extraOptions);
};
